import { useMapEvents } from 'react-leaflet';

function MapClickHandler({ onMapClick }) {
  useMapEvents({
    click: (e) => {
      // Only handle click if it's not on a marker
      if (!e.originalEvent.target.closest('.leaflet-marker-icon')) {
        onMapClick();
      }
    },
  });
  return null;
}

export default MapClickHandler;